// This component is made dynamic project,work, and services page
import { useNavigate } from "react-router-dom";

import moreArrow from '../../constants/moreArrow.js'
import MoreArrow from '../../components/Helper/MoreArrow';

import "../../styles/textHighlighter.css"

const styles = {
    mainWrapper: "grid grid-cols-1 md:grid-cols-2 my-10",
    imgStyle: "h-full w-full px-2 sm:px-0 sm:h-5/6 sm:w-11/12 xl:w-10/12 2xl:h-4/6 2xl:w-9/12 rounded-lg",
    h2Heading: "font-semibold text-xl 2xl:text-3xl mb-5 mt-5 md:mt-0",
    pText: "text-[#333333] text-xs lg:text-sm leading-4 lg:leading-5 2xl:text-lg 2xl:leading-1  highlight-text-primary",
}

const ImageContent = ({ mainSection, BLEND_HEADING_1, PARAGRPH_1, PARAGRPH_2, link, order_1 }) => {
    const navigate = useNavigate();
  return (
    <div className={styles.mainWrapper}>
      <div className={order_1 === 1 ? " lg:order-1" : "lg:order-2 flex justify-end"}>
        <img
          src={mainSection}
          alt="dummy"
          className={styles.imgStyle}
        />
      </div>

      <div className={order_1 === 1 ? "flex flex-col lg:order-2 xl:w-10/12 xl:ml-28 2xl:ml-36" : "flex flex-col lg:order-1 xl:w-10/12" }>
        {/* <div className="bg-red-500 w-full"> */}
          <h2 className={order_1 === 1 ? styles.h2Heading.concat(" first-letter:text-tertiary") : styles.h2Heading.concat(" first-letter:text-primary") }>
              {BLEND_HEADING_1}
          </h2>
        {/* </div> */}
        <p className={styles.pText}>
            {PARAGRPH_1}
        </p>
        <p className={styles.pText.concat(" mt-2")}>
            {PARAGRPH_2}
        </p>
        {
          window.location.pathname === "/work" ?
          (
            <p className={styles.pText.concat(" mt-2")}
              onClick={() => navigate(link)}
            >
              <MoreArrow text={moreArrow.TEXT_EXPLORE_PROJECT} />
            </p>
          ):(<></>)
        }
      </div>
    </div>
  );
};

export default ImageContent;
